<template lang="pug">
	no-ssr(v-if="!userSubscribed()")
		div.side-row
			div
				div.text-right(style="display: block;margin-bottom: 30px")
					sfc-dfp-ad(:ad-unit="rightBannerAdUnit" sizes="[[160,600],[300, 600],[300, 250]]")
			div.text-right
				div
					sfc-dfp-ad(ad-unit="savingforcollege_other_right_text_1" sizes="[[160,160],[300,80]]")
				div
					sfc-dfp-ad(ad-unit="savingforcollege_other_right_text_2" sizes="[[160,160],[300,80]]")
				div
					sfc-dfp-ad(ad-unit="savingforcollege_other_right_text_3" sizes="[[160,160],[300,80]]")

	div(v-else)
		.sidebar-content#latest-articles
			.section
				h3
					| Latest Articles
				span(v-for="article of articles" )
					a.article-content(:href="`${$store.state.config.sfcHost}/article/${article.slug}`")
						.article-title(v-html="article.title.rendered")
						p(v-html="article.excerpt.rendered")
						p.author(v-show="article.author_name && article.author_name != ''") by {{article.author_name}}
				.more-articles
					a(href="/articles/all") More articles

</template>
<style lang="stylus" scoped>
@import '~assets/css/variables.styl'
.side-row
	position sticky
	top: 0
	padding-top: 60px

.sidebar-content
	margin-top: 45px

.article-content
	padding: 15px 0
	text-decoration: none
	.article-title
		text-decoration: none
		font-size: body-font-size-md
		margin-bottom: 15px
		color: body-font-color
	p
		text-decoration: none!important
		font-size: body-font-size-sm
		color: body-font-color
	.article-author
		color: #A9B4C2
		text-decoration: none!important
	&:hover
		.article-title
			text-decoration: underline!important
		p
			text-decoration: none!important
		.article-author
			text-decoration: none!important
			padding-top: 15px

#latest-articles
	h3
		padding-bottom: 15px
		margin-bottom: 20px
		border-bottom: 1px solid #ced3e1
	span
		display: block
		margin-bottom: 20px
	.article-title
		font-weight: body-font-weight-strong
	p
		margin-bottom: 10px
	p.author
		color: #a3a5ad
		margin-bottom: 25px
	.more-articles
		text-align: right
		a
			text-decoration: underline
</style>

<script>
	export default {

		async created(){
			if(this.userSubscribed()){
				try {
					const wpApiUrl = `${this.$store.state.config.wordpressApiUrl}/article`
					const params = {
					per_page: "3",
					_fields: 'id,title,slug,excerpt,author,date,author_name'
					}
					const response = await this.$httpService.get(wpApiUrl, params)
					this.articles = response
				} catch (e) {
					console.log(e)
					return
				}
			}

		},
		methods: {
			userSubscribed(){
				return (this.$store.state.sfcSubscriptions && this.$store.state.sfcSubscriptions.subscription_order_id)
			}
		},

		data(){
			let rightBannerAdUnit = (this.$route.path.indexOf('/pro-dashboard')>=0) ? 'savingforcollege_prodashboard_right_skyscraper' : 'savingforcollege_other_right_wide_skyscraper'
			return {
				ready: true,
				articles: [],
				rightBannerAdUnit
			}
		}
	}
</script>
